import type { LogLayerPlugin } from "loglayer";

/**
 * LogLayer plugin copying the message prefix (`log.withPrefix("[sync]")`) into the `log.context` attribute (`sync`),
 * so the logs can be filtered by context in the log backend (the prefix itself is only part of the message).
 */
export function prefixContextPlugin(): LogLayerPlugin {
    return {
        id: "prefix-context",
        onBeforeDataOut: ({ data, prefix }) => {
            if (!prefix) {
                return data;
            }
            return { "log.context": prefixToContext(prefix), ...data };
        },
    };
}

/** `[sync]` → `sync` */
export function prefixToContext(prefix: string): string {
    return prefix.replace(/^\[(.*)\]$/, "$1").trim();
}
